import doubleSameItem from './partials/double-same-item'

const doubleSameBase = {
    DoubleSame: {
        baseStyle: ({isMobileRow, backgroundColor, isBeforeRightMobile}) => ({
            grid: {
                templateColumns: 'repeat(12, 1fr)',
                gap: 'spacing.0',
            },
            gridItemLeft: {
                colSpan: {base: isMobileRow ? 6 : 12, md: 6},
            },
            gridItemRight: {
                colSpan: {base: isMobileRow ? 6 : 12, md: 6},
                order: {base: isBeforeRightMobile ? '-1' : 'unset', md: 'unset'},
            },
            wrapper: {
                bg: backgroundColor ? backgroundColor : 'color.background.transparent',
                w: '100%',
                gridColumn: '1 / -1', // Starts from the first column end ends at the last column
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            },
            itemWrapper: {
                height: '100%',
            },
        }),
    },
}

const doubleSame = {
    ...doubleSameBase,
    ...doubleSameItem,
}

export default doubleSame
